export default "__VITE_ASSET__BTTdNHeu__ 640w, __VITE_ASSET__BuMYFwkF__ 1024w";